import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-3 flex items-center gap-2">
          <span className="h-3 w-[3px] rounded-full bg-primary-500" />
          <span className="font-label text-xs tracking-[0.3em] text-primary-300 uppercase">{eyebrow}</span>
        </div>
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
        {desc ? <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p> : null}
      </div>
      {action}
    </div>
  );
}